var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldRam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 8V7c0-3-1.53-5-5-5h-7c-3.53 0-5 2-5 5v10c0 2.53 1.05 4.34 3.49 4.84L6.98 19c0-1.66 1.35-3 3-3h4.01c1.64 0 2.99 1.34 3 2.98l.013 1.9a.5.5 0 0 0 .804.393C19.602 19.9 20.5 18.476 20.5 17v-1.17c0-.53-.21-1.04-.59-1.42l-.82-.82c-.38-.38-.59-.89-.59-1.42V10c0-.55.45-1 1-1s1-.45 1-1zm-12.53.53c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h6a.749.749 0 1 1 0 1.5h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.994 20.987 7.98 19a2 2 0 0 1 2-2h4.01c1.1 0 1.99.89 2 1.99l.02 1.98a1 1 0 0 1-1 1.01H8.994a1 1 0 0 1-1-.993z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldRam);
export default __webpack_public_path__ + "static/media/vuesax-bold-ram.57bab1e790028d2638e9082308f161a3.svg";
export { ForwardRef as ReactComponent };